module.exports = __webpack_public_path__ + "static/img/3.7ecc6c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/3.png
// module id = hwQZ
// module chunks = 0